import { useRouter } from 'next/router';
import { BreadcrumbJsonLd } from 'next-seo';
import { ItemListElements } from 'next-seo/lib/types';

import METADATA from 'src/constants/metadata';
import { Breadcrumb, PageHeaderProps } from 'src/interface/Layout/PageHeader';

interface BreadcrumbJsonLdCProps {
	pageHeaderContent: PageHeaderProps;
}

const BreadcrumbJsonLdC = (props: BreadcrumbJsonLdCProps) => {
	const r = useRouter();

	const convertItems = () => {
		let items: ItemListElements[] = [];

		props.pageHeaderContent?.breadcrumbs?.map((breadcrumb: Breadcrumb, i: number) => {
			return items.push({
				position: i + 1,
				name: breadcrumb.label,
				item: METADATA.WEB_URL + (breadcrumb.navigatePath || r.asPath),
			});
		});

		return items;
	};
	return <BreadcrumbJsonLd itemListElements={convertItems()} />;
};

export default BreadcrumbJsonLdC;
